import React, { useEffect } from "react";
import { Media } from "reactstrap";
import Avatar from "@material-ui/core/Avatar";
import userImage from "../../static/img_avatar.png";
import NotificationServices from "../../services/notficationService";
import { withRouter } from "react-router-dom";

const Notifications = ({ data, history }) => {
  // let history = useHistory();
  // let route = data.alert.page
  //console.log(data.notifications);
  //console.log(data.alert[0].from.display_picture);
  // const notificationsData = [
  //   {
  //     id: data.alert._id,
  //     avatar: userImage,
  //     message: data.alert.message,
  //     date: "3 min ago"
  //   }
  // ];
  const navigation = async notifications => {
    let details = NotificationServices.readnotification(notifications);
    console.log(notifications);
    history.push(`${notifications.page}`);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        // second: 'numeric',
        hour12: true
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
}

const timeAgo = (date) => {
    const notificationDate = new Date(date);
    return formatDateTime(notificationDate);
}




  return (
  
    data.notifications &&
    // data.notifications.length &&
    data.notifications.map(notify => (
      <>
      <Media key={notify._id} className="row">
        <Media left className="align-self-center pr-3 ml-2 col-md-2">
          <Avatar
            tag={Media}
            object
            src={notify.from ? notify.from.display_picture : userImage}
            title=""
            style={{ cursor: "pointer", border:'1px solid black' }}
          />
        </Media>
        <Media
          style={{ cursor: "pointer" }}
          body
          middle
          className="align-self-center col-md-10"
          onClick={() => navigation(notify)}
        >
          {notify.message}
        </Media>
        <Media className="col-md-3">
          <p style={{color:'blue', fontSize:'10px', position:'relative', bottom: '-35px', marginLeft:'-65px'}}>{timeAgo(notify.date)}</p>
        </Media>
        {/* <Media right className="align-self-center">
          <small className="text-muted">{date}</small>
        </Media> */}
      </Media>
      <hr/>
      </>
    )
    
    )

    
  );
};

export default withRouter(Notifications);
